import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlAuxiliarDirective } from 'src/app/directives/FormControlAuxiliar.directive';
import { CustomTooltipRenderDirective } from './customTooltip.directive';

@NgModule({
    declarations: [ FormControlAuxiliarDirective, CustomTooltipRenderDirective ],
    imports: [ CommonModule ],
    exports: [ FormControlAuxiliarDirective, CustomTooltipRenderDirective ],
    providers: [],
})
export class DirectivesModule {}